import type { CarFeatureConfig } from '../../../types/insurances/CarFeatureConfig';

export const car: CarFeatureConfig = {
    overview: {
        details: {
            showPackage: false,
            showRisksInList: false,
            showSpecialTranslationKeyForParticipationAllRisks: false,
            fallbackAssistancePhonesKey: 'HR',
            fallbackAssistanceEmailsKey: 'HR',
        },
    },
    history: {
        visible: false,
    },
};
